import { Link } from "react-router-dom";
import "../Services.css";
import { useState } from "react";

const FAQSection = () => {
  const faqs = [
    {
      question: "1. How is CFO Advisory different from traditional accounting services?",
      answer:
        "While accounting focuses on maintaining financial records and complying with tax regulations, CFO Advisory goes a step further by providing strategic insights and planning. CFO Advisory helps businesses optimize financial performance, plan for the future, and make informed, data-driven decisions.",
    },
    {
      question: "2. How can CFO Advisory help my business grow?",
      answer:
        "CFO Advisory helps your business grow by providing strategic financial advice on budgeting, managing cash flow, making informed investment decisions, optimizing operations, and identifying growth opportunities. We guide you through financial challenges and ensure your business is on a sustainable growth path.",
    },
    {
      question: "3. How do I get started with your CFO Advisory services?",
      answer:
        "To get started, simply reach out to us for a consultation. We’ll discuss your business goals, challenges, and financial needs, then create a customized advisory plan to help you achieve financial success.",
    },
    {
      question: "4. What is the difference between a CFO and an accountant?",
      answer:[
         "Accountant – Focuses on bookkeeping, tax preparation, and compliance.",
        "CFO – Provides high-level financial strategy, forecasting, and business growth planning."
      ].join('\n')
       
    },
  ];

  const [openIdx, setOpenIdx] = useState(null);
  const toggle = (idx) => setOpenIdx((prev) => (prev === idx ? null : idx));

  return (
    <div className="faq-section py-5">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="section-title1">CFO Advisory FAQs</h2>
          <Link to="/pricing" className="see-plan-link">
            See Plan &rarr;
          </Link>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="faq-accordion">
              {faqs.map((faq, index) => {
                const isOpen = openIdx === index;
                const isString = typeof faq.answer === 'string';
                return (
                  <div className="faq-item" key={index}>
                    <button
                      type="button"
                      className="faq-toggle"
                      aria-expanded={isOpen}
                      aria-controls={`faq-content-${index}`}
                      onClick={() => toggle(index)}
                    >
                      <h5 className="faq-question m-0">{faq.question}</h5>
                      <span className="faq-icon" aria-hidden>{isOpen ? '−' : '+'}</span>
                    </button>
                    <div
                      id={`faq-content-${index}`}
                      className={`faq-content ${isOpen ? 'open' : ''}`}
                      role="region"
                    >
                      <div className="faq-content-inner">
                        {isString ? (
                          <p className="faq-answer" style={{ whiteSpace: 'pre-line', marginBottom: 0 }}>{faq.answer}</p>
                        ) : (
                          <div className="faq-answer">{faq.answer}</div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;

